import "./index.scss";
import { EXTERNAL_LINKS } from "routes/paths";

export const VisitHelpCenter = () => {
  return (
    <section
      className="visit-help-center-container"
      data-testid="visit-help-center"
    >
      <div className="help-text-wrapper">
        <h2 className="help-title">Still have questions?</h2>
        <h3 className="help-subtitle">We’re happy to help!</h3>
      </div>
      <a
        className="help-center-anchor"
        href={EXTERNAL_LINKS.MARKETPLACE_ZENDESK}
      >
        VISIT HELP CENTER
      </a>
    </section>
  );
};
